/* global tinymce */
import { getCurrentLocationtemplate } from "../../shortcodes/templates";

const dynamicLocationConfig = {
  title: "Dynamic Location",
  body: {
    type: "panel",
    items: [
      {
        type: "listbox",
        name: "countryFormatType",
        label: "Select Country Format",
        disabled: false,
        items: [
          {
            text: "Country Long: United States",
            value: "country_long",
          },
          {
            text: "Country Short: US",
            value: "country_short",
          },
          {
            text: "Region/State: Illinois",
            value: "region",
          },
          {
            text: "City: New York",
            value: "city",
          },
          {
            text: "Zip code",
            value: "zipcode",
          },
        ],
      },
    ],
  },
  buttons: [
    {
      type: "cancel",
      name: "closeButton",
      text: "Cancel",
    },
    {
      type: "submit",
      name: "submitButton",
      text: "Insert",
      primary: true,
    },
  ],
  onSubmit: function (api) {
    tinymce.activeEditor.execCommand(
      "mceInsertContent",
      false,
      getCurrentLocationtemplate(api.getData().countryFormatType),
    );
    api.close();
  },
};

export { dynamicLocationConfig };
